export const getFieldPropertiesByTarget = (form, options)=>{
    if (!form.fields) {
        return undefined;
    }
    return form.fields?.reduce((result, field)=>{
        if (!field?.target) {
            return result;
        }
        if (options?.fqdn && !field.dataExtensionsDetails?.fqdns?.includes(options.fqdn)) {
            return result;
        }
        if (field.nestedFormId) {
            const nestedForm = form.nestedForms?.find((_nestedForm)=>_nestedForm.form?.id === field.nestedFormId)?.form;
            if (nestedForm) {
                result[field.target] = getFieldPropertiesByTarget(nestedForm, options);
            }
            return result;
        }
        result[field.target] = {
            required: Boolean(field.validation?.required),
            hidden: Boolean(field.hidden),
            fieldType: field.view?.fieldType,
            label: field.view?.label
        };
        return result;
    }, {});
};

//# sourceMappingURL=get-field-properties-by-target.js.map